import { SubmitHandler, useForm, FieldErrors } from "react-hook-form";

import { ZodType, z } from "zod";

import { zodResolver } from "@hookform/resolvers/zod";
import { UseMutateFunction } from "@tanstack/react-query";

export const useFormFactory = <T extends ZodType<TODO, TODO, TODO>>({
  schema,
  mutate,
  onError,
}: {
  schema: T;
  mutate: UseMutateFunction<unknown, unknown, z.infer<typeof schema>>;
  onError?: (errors: FieldErrors<z.infer<typeof schema>>) => void;
}) => {
  const { handleSubmit, register, ...rest } = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });

  const onSubmit: SubmitHandler<z.infer<typeof schema>> = async (data) => {
    mutate(data);
  };

  const onSubmitHandler = handleSubmit(onSubmit, (errors) => {
    if (onError) {
      onError(errors);
    }
  });

  return {
    register,
    onSubmitHandler,
    ...rest,
  };
};
